import {Pipe, PipeTransform} from '@angular/core';
import {Crop} from '@6grain/masofa-monolith-api-client/dictionaries';
import {CROP_COLOR_MAP} from '@app/utils/_crop-colors';

export interface CropColorData {
  colors: string[];
  names: string[];
}

@Pipe({
  name: 'fieldCropsColor',
  standalone: true
})
export class FieldCropsColorPipe implements PipeTransform {

  private readonly CROP_COLOR_MAP: { [key: string]: string } = CROP_COLOR_MAP;

  transform(crop: Crop, opacity?: number): string {
    if (!crop) {
      return this.applyOpacity('rgba(119, 255, 15, 0.34)', opacity);
    }

    const cropName: string = crop.names ? crop.names['en-US'] as string : 'Unknown';

    return this.applyOpacity(this.getCropColor(cropName), opacity);
  }

  private applyOpacity(color: string, opacity?: number): string {
    if (opacity === undefined || opacity === null) return color;

    // Handle rgba(r, g, b, a)
    const rgbaMatch = color.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*[\d.]+)?\)$/);
    if (rgbaMatch) {
      return `rgba(${rgbaMatch[1]}, ${rgbaMatch[2]}, ${rgbaMatch[3]}, ${opacity})`;
    }

    // Handle hex #rrggbb or #rgb
    const hexMatch = color.match(/^#([0-9a-fA-F]{3,8})$/);
    if (hexMatch) {
      let hex = hexMatch[1];
      if (hex.length === 3) hex = hex.split('').map(c => c + c).join('');
      const r = parseInt(hex.slice(0, 2), 16);
      const g = parseInt(hex.slice(2, 4), 16);
      const b = parseInt(hex.slice(4, 6), 16);
      return `rgba(${r}, ${g}, ${b}, ${opacity})`;
    }

    return color;
  }

  private getCropColor(cropName: string): string {
    if (this.CROP_COLOR_MAP[cropName]) {
      return this.CROP_COLOR_MAP[cropName];
    }

    const partialMatch = Object.keys(this.CROP_COLOR_MAP).find(key =>
      cropName.toLowerCase().includes(key.toLowerCase()) ||
      key.toLowerCase().includes(cropName.toLowerCase())
    );

    return partialMatch ? this.CROP_COLOR_MAP[partialMatch] : 'rgba(119, 255, 15, 0.34)'; // Default to gray
  }
}
